const clean = (value) => String(value || '').trim();

const optionsFrom = (tasks, valueSelector, labelSelector = valueSelector) => {
  const options = new Map();
  tasks.forEach((task) => {
    const value = clean(valueSelector(task));
    const label = clean(labelSelector(task));
    if (value && label && !options.has(value)) options.set(value, { value, label });
  });
  return [...options.values()].sort((left, right) => left.label.localeCompare(right.label));
};

export const buildAuditTaskFilterOptions = (tasks = []) => {
  const list = Array.isArray(tasks) ? tasks : [];
  return {
    assignees: optionsFrom(list, (task) => task?.assignedUserId, (task) => task?.assignedUsername),
    clients: optionsFrom(list, (task) => task?.companyName),
    standards: optionsFrom(list, (task) => task?.standardName),
    services: optionsFrom(list, (task) => task?.serviceName),
    cycles: optionsFrom(list, (task) => {
      const cycle = clean(task?.auditCycle);
      if (/initial/i.test(cycle)) return 'Initial';
      if (/surveillance/i.test(cycle)) return 'Surveillance';
      if (/recert/i.test(cycle)) return 'Recertification';
      return cycle;
    }),
    taskTypes: optionsFrom(list, (task) => task?.taskTypeCode, (task) => task?.taskType || task?.taskTypeCode),
  };
};

export const filterAuditTasks = (tasks = [], filters = {}) => (Array.isArray(tasks) ? tasks : []).filter((task) => {
  if (filters.assignedUser && clean(task?.assignedUserId) !== clean(filters.assignedUser)) return false;
  if (filters.client && clean(task?.companyName) !== filters.client) return false;
  if (filters.standard && clean(task?.standardName) !== filters.standard) return false;
  if (filters.service && clean(task?.serviceName) !== filters.service) return false;
  if (filters.taskType && clean(task?.taskTypeCode) !== filters.taskType) return false;
  if (filters.auditCycle) {
    const expected = filters.auditCycle.toLowerCase();
    if (!clean(task?.auditCycle).toLowerCase().includes(expected)) return false;
  }
  return true;
});
